import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import { DialogCloseSaveButtons } from 'components/Common/DialogActionButtons/DialogCloseSaveButtons'
import { MoneyInput } from 'components/Common/Input/MoneyInput'
import { setPurchasingPartAndPricePerItem } from 'features/BillOfMaterials/store/asyncActions/setPurchasingPartAndPricePerItem'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  MoneyDto,
  PriceScope,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppDispatch, useAppSelector } from 'store/configureStore'

export type PurchasingPartDialogProps = {
  bomItemId: string
  isOpen?: boolean
  onClose?: () => void
}

export const PurchasingPartDialog = (props: PurchasingPartDialogProps) => {
  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  const salesPricePerItem = useAppSelector(
    projectSelectors.bomItemFinancialSelector(
      props.bomItemId,
      'salesPricePerItem'
    )
  )

  const [changedPrice, setChangedPrice] = useState<MoneyDto>(
    salesPricePerItem as MoneyDto
  )

  const saveChangedAction = (value: MoneyDto) => {
    setChangedPrice(value)
  }

  const handleSave = () => {
    if (changedPrice) {
      dispatch(
        setPurchasingPartAndPricePerItem({
          bomItemId: props.bomItemId,
          materialCostPrice: changedPrice,
          priceScope: PriceScope.Unit,
        })
      )
    }

    props.onClose()
  }

  const operationPending = useAppSelector(
    projectSelectors.projectOperationPendingSelector.projectOperationIsPendingSelector(
      setPurchasingPartAndPricePerItem.typePrefix.concat('/', props.bomItemId)
    )
  )

  return (
    <Dialog open={props.isOpen} onClose={props.onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('project:purchasing-part-set')}</DialogTitle>
      <DialogContent>
        <MoneyInput
          label={t('project:price-per-item', 'price/item')}
          value={changedPrice ?? (salesPricePerItem as MoneyDto)}
          onChange={(e) => saveChangedAction(e.currentTarget.value)}
          autoFocus
        />

        {/* <ProjectTextField
          valueSelector={
          saveAction={saveChangedAction}
          actionTypePrefix={setPurchasingPartAndPricePerItem.typePrefix.concat(
            '/',
            props.bomItemId
          )}
          money
          disableShowHelpText
          textFieldProps={{
            // type: 'number',
            label: t('project:price-per-item', 'price/item'),
            required: true,
            inputProps: {
              style: {
                textAlign: 'right',
                width: '90px',
              },
            },
          }}
          validation={valueGreaterThanZero}
        /> */}
      </DialogContent>

      <DialogActions>
        <DialogCloseSaveButtons
          onCloseButtonClicked={props.onClose}
          onSaveButtonClicked={handleSave}
          // saveButtonDisabled={!changedPrice}
          saving={operationPending}
        />
      </DialogActions>
    </Dialog>
  )
}
